import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpClient.service';
import { marksheetVerificationApis,previousQualificationApis } from '../../constants/master-tools-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class MasterToolsService {
  permissions_entity = permissionEntity;

  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
) { }

  getMarksheetList(pagination: PaginationType, filters?: any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
    let query = '?';
    if (filters) {
        query += filters;
    }
    if (sort) { ///? for sorting
      query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
  }
    query += userParams.call(this, this.permissions_entity.modules.marksheet_verfication);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;

    return this.httpClientService.get(`${marksheetVerificationApis.getMarksheetList}${query}`);
  }

  getMarksheetById(id: string): Observable<any> {
      return this.httpClientService.get(`${marksheetVerificationApis.getMarksheetbyId}${id}`);
  }

  getMarksheetUploadedDoc(id: string, pagination: PaginationType): Observable<any> {
    return this.httpClientService.get(`${marksheetVerificationApis.getMarksheetUploadedDoc}${id}&skip=${pagination.skip}&limit=${pagination.limit}`);
}

  createMarksheet(payload: unknown): Observable<any> {
      return this.httpClientService.post(marksheetVerificationApis.createMarksheet, payload);
  }

  updateMarksheet(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(marksheetVerificationApis.updateMarksheetById.replace(':marksheetId', id), payload);
  }

  marksheetUpload(payload: unknown): Observable<any> {
    return this.httpClientService.upload(marksheetVerificationApis.marksheetUpload, payload);
  }

  deleteMarksheet(id: string): Observable<any> {
      return this.httpClientService.delete(marksheetVerificationApis.deleteMarksheetbyId.replace(':marksheetId', id));
  }

  getQualificationList(pagination: PaginationType, filters?: any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
    let query = '?';
    if (filters) {
        query += filters;
    }
    if (sort) { ///? for sorting
      query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
  }
    query += userParams.call(this, this.permissions_entity.modules.student_previous_qualification);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${previousQualificationApis.getQualificationList}${query}`);
  }

  getQualificationById(id: string): Observable<any> {
      return this.httpClientService.get(previousQualificationApis.getQualificationbyId.replace(':studentPreviousQualificationId', id));
  }

  createQualification(payload: unknown): Observable<any> {
      return this.httpClientService.post(previousQualificationApis.createQualification, payload);
  }

  updateQualification(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(previousQualificationApis.updateQualificationById.replace(':studentPreviousQualificationId', id), payload);
  }

  deleteQualification(id: string): Observable<any> {
      return this.httpClientService.delete(previousQualificationApis.deleteQualificationbyId.replace(':studentPreviousQualificationId', id));
  }

  getQualificationDropDown(pagination: PaginationType, filters?: any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
    let query = '?';
    if (filters) {
        query += filters;
    }
    if (sort) { ///? for sorting
      query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
  }
    query += userParams.call(this, this.permissions_entity.modules.student_previous_qualification);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${previousQualificationApis.getQualificationList}${query}`);
  }
}
